import { cleanTime, storeTime } from '@/utils/timeSpent'
import * as constants from './constants'

export default function handleCustomEvents() {
  document.addEventListener(constants.flowEvent, storeTime)
  document.addEventListener(constants.cleanFlowEvent, cleanTime)
}
